import ConnectedModal from './ConnectedModal';

export default ConnectedModal;
